<template>
  <auth-container>
    <h2 class="text-2xl mb-4">Loading...</h2>
  </auth-container>
</template>

<script>
 import api from '@/api'
 import {mapState, mapActions} from 'vuex'
 import AuthContainer from '@/components/AuthContainer'

 export default {
   data() {
     return {
       success: false
     }
   },

   components: {AuthContainer},

   computed: Object.assign(
     mapState({
       member: state => state.member
     }),
   ),

   async created () {
       const {res, err} = await api.verifyTelegramConnection(this.$route.params.token);

       if (err) {
         
       } else {
         this.$router.replace({name: 'account'});
       }
   },

   watch: {

   }
 }
</script>
